module.exports = __webpack_public_path__ + "img/771.12b7cf3f.jpg";